require('./languages/Izenda.texts.en-US');



// WEBPACK FOOTER //
// ./locales/Izenda.Locales.js